/*
* Copyright (c) CJSC PETER-SERVICE, 2019.
*/
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */
import {
    backgroundColorHoverOpacity,
    backgroundColorWhite,
    FreshAsphalt,
    textColorOpacity,
} from './palette';

export const superSearchBgColor = backgroundColorWhite;
export const superSearchBgHoverColor = backgroundColorHoverOpacity;
export const superSearchText = FreshAsphalt;
export const superSearchTextSecondary = textColorOpacity;
export const superSearchBgLoader = `linear-gradient(
    to right,
    rgba(216, 216, 216, 0.5) 8%,
    rgba(238, 238, 238, 0.5) 33%,
    rgba(216, 216, 216, 0.5) 60%)`;
